import {Component, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {IExgTab} from 'exc-tab-v2';
import {DataService} from '../../../services/data.service';

@Component({
  selector: 'app-tab-settings-global',
  templateUrl: './tab-settings-global.component.html',
  styles: []
})
export class TabSettingsGlobalComponent extends ExcTranslation implements IExgTab, OnInit {

  Data: any;
  tabinstance: any;

  GlobalSettingsObject: any = {
    setWert1914Faktor: 0
  };
  initialData: any = {};

  get changed(): boolean {
    let rt = false;
    if(Number(this.GlobalSettingsObject.setWert1914Faktor) !== Number(this.initialData.setWert1914Faktor))
      rt = true;
    return rt;
  }

  constructor(private dataSvc: DataService) {
    super();

  }

  ngOnInit(): void {
    this.tabinstance.Label = this.getRessource('Label');
    this.loadData();
  }

  loadData(): void {
    this.dataSvc.Settings.Global.GetSummary().subscribe(result => {
      this.GlobalSettingsObject.setWert1914Faktor = result.data.GlobalSettings.setWert1914Faktor;
      this.initialData = Object.assign({}, this.GlobalSettingsObject);
    });
  }

  saveData(): void {
    this.dataSvc.Settings.Global.Update(this.GlobalSettingsObject).subscribe(result => {
      this.GlobalSettingsObject.setWert1914Faktor = result.data.GlobalSettings.setWert1914Faktor;
      this.initialData = Object.assign({}, this.GlobalSettingsObject);
    });
  }
}

